import {
  CREATE_REGISTER_SUCCESS,
  CREATE_REGISTER_FAIL,
  RETRIEVE_REGISTER_SUCCESS,
  RETRIEVE_REGISTER_FAIL,
  UPDATE_REGISTER_SUCCESS,
  UPDATE_REGISTER_FAIL,
  DELETE_REGISTER_SUCCESS,
  DELETE_REGISTER_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_REGISTER_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_REGISTER_SUCCESS:
      return payload;

    case RETRIEVE_REGISTER_FAIL:
      return [...datas];

    case UPDATE_REGISTER_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_REGISTER_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
